'use strict';
/**
* @class faq
*/

// jquery accordion
require('jquery-ui/ui/widgets/accordion');

const ajax = require('../modules/ajax'),
    getScreenBreakpointSize = require('../modules/util/getScreenBreakpointSize'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    isMobileWidth = require('../modules/util/isMobileWidth'),
    customerservice = require('../customerservice'),
    ritualsFormHelper = require('../rituals-form-helper.js'),
    validator = require('../validator');

const faq = {
    def : {
        headerHeight : 60,
        classResponsive: 'faq-view-mobile',
        container : $('.js-faq-container'),
        item : $('.js-faq-menu-item'),
        optionFirst : $('.js-faq-menu-option:first-child'),
        option : $('.js-faq-menu-option'),
        rightContent : $('.faq-right-content'),
        breakpointSize : getScreenBreakpointSize($(window).width())
    },

    getResponsiveDesign: function () {
        if (faq.def.breakpointSize === 'small') {
            faq.def.container.addClass(faq.def.classResponsive);
        } else {
            faq.def.container.removeClass(faq.def.classResponsive);
        }

        faq.def.rightContent.find('.js-faq-back-button').click(function(){
            faq.def.container.removeClass('active-content');
            $('.faq-contact').removeAttr('style');
        });
    },

    getContentFromFolder : function(folderId, activeQuestionId){
        ajax.load({
            type: 'POST',
            url: Urls.pageFaq,
            target: $('.js-ajax-content'),
            data: {fid: folderId},
            callback: function () {
                let active = false;
                if (activeQuestionId){
                    //Get the question that should start out active
                    const accordionOptions = $('.js-faq-accordion [data-qid]');
                    const selectedOption = $('.js-faq-accordion [data-qid=' + activeQuestionId + ']');
                    const selectedQuestionIndex = accordionOptions.index(selectedOption);
                    if (selectedQuestionIndex > -1) {
                        active = selectedQuestionIndex;
                    }
                }

                $('.js-faq-accordion').accordion({
                    collapsible : true,
                    active: active,
                    header: '> li > :first-child',
                    icons : {
                        'header' : 'icon-plus2',
                        'activeHeader': 'icon-minus2'
                    },
                    heightStyle: 'content',
                    beforeActivate: function(event, ui) {
                        let currHeader;
                        let currContent;

                        // The accordion believes a panel is being opened
                        if (ui.newHeader[0]) {
                            currHeader = ui.newHeader;
                            // The accordion believes a panel is being closed
                        } else {
                            currHeader = ui.oldHeader;
                        }

                        // Since we've changed the default behavior, this detects the actual status
                        const isPanelSelected = currHeader.attr('aria-selected') == 'true';

                        const questionId = $(currHeader).closest('li').data('qid');
                        if (isPanelSelected) {
                            const questionIdInUrl = getQueryStringParams(window.location.search)['qid'];
                            if (questionIdInUrl == questionId) { //Closing the panel currently in the URL
                                const url = removeParamFromURL(window.location.href, 'qid');
                                setUrl(url);
                            }
                        } else {
                            const url = replaceParameterInUrl(window.location.href, 'qid', questionId);
                            setUrl(url);
                        }

                        if (!isMobileWidth()) {
                            currContent = currHeader.next('.ui-accordion-content');

                            // Toggle the panel's header
                            currHeader.stop().toggleClass('ui-corner-all',isPanelSelected).toggleClass('accordion-header-active ui-state-active ui-corner-top', !isPanelSelected).attr('aria-selected', ((!isPanelSelected).toString()));

                            // Toggle the panel's icon
                            currHeader.children('.ui-icon').toggleClass('icon-plus2',isPanelSelected).toggleClass('icon-minus2', !isPanelSelected);

                            // Toggle the panel's content
                            currContent.stop().toggleClass('accordion-content-active',!isPanelSelected);

                            if (isPanelSelected) {
                                currContent.slideUp();
                            } else {
                                currContent.slideDown();
                            }

                            return false; // Cancels the default action
                        }
                    }
                });
                $('.faq-contact').show();
                faq.getResponsiveDesign();
            }
        });
    },

    getContactForm: function () {
        const url = appendParamToURL(Urls.contactUs, 'format', 'ajax');
        ajax.load({
            url: url,
            target: $('.js-ajax-content'),
            callback : function () {
                window.scrollTo(0, 0);
                $('.faq-contact').hide();
                faq.def.rightContent.find('h1').prepend('<span class="icon--medium icon-arrow3--left"></span>');
                faq.getResponsiveDesign();
                customerservice.init();
                $('.js-ajax-content').find('.js-custom-select').selectric();
                $('.js-faq-container').find('.js-faq-menu-item.active').focus();
                $('.js-toaster-container').addClass('page-loaded');
                if (isMobileWidth()) {
                    $('body > .js-contactus-toaster').remove();
                    $('.js-contactus-toaster').appendTo($('body'));
                }
                ritualsFormHelper.init();
                validator.init();
                faq.def.container.addClass('active-content');
            }
        });
    },

    init : function() {
        // get URL params
        const params = getQueryStringParams(window.location.search),
            linkedCategory = params['catid'],
            linkedQuestion = params['qid'];

        // get first FAQ category option
        const firstOption = $(faq.def.option[0]);

        // if URL params link to an FAQ category, load it
        if (linkedCategory){
            const selectedOption = faq.def.option.filter('[data-href=' + linkedCategory + ']');

            if (selectedOption.length == 0) {
                loadCategory(firstOption, true);
            } else {
                loadCategory(selectedOption, false, linkedQuestion);
            }

        } else {
            if (faq.def.breakpointSize !== 'small') {
                loadCategory(firstOption, true);
            }
        }

        faq.getResponsiveDesign();

        $('.js-first-item-show').click(function(){
            loadCategory($(faq.def.option[0]), true);
        });

        $('em.js-display-contact-form').attr('tabindex', 0);

        $('.js-display-contact-form').click(function(){
            faq.getContactForm();
        });

        $('.js-display-contact-form').on('keyup', function(e){
            if (e.which == 13) {
                faq.getContactForm();
            }
        });

        faq.def.option.click(function(){
            loadCategory($(this), false);
        });

        $('.js-faq-menu-item').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        $(window).resize(function() {
            faq.getResponsiveDesign();
        });
    }
};

/**
 *
 * @param {jQuery Element} categoryElement The jQuery element representing the category to load
 * @param {bool} clearUrlCategory If true, the category id parameter will be removed from the URL
 * @param {string} activeQuestionId The question ID that should be activated once loaded. Leave empty to not activate any question
 */
function loadCategory(categoryElement, clearUrlCategory, activeQuestionId){

    let url = window.location.href;

    if (!activeQuestionId) {
        url = removeParamFromURL(window.location.href, 'qid'); //Remove the 2nd-level parameter
    }

    if (clearUrlCategory) {
        url = removeParamFromURL(url, 'catid');
    } else {
        url = replaceParameterInUrl(url, 'catid', categoryElement.data('href'));
    }

    setUrl(url);

    faq.def.option.removeClass('active');
    categoryElement.addClass('active');
    faq.def.container.removeClass('fixed');
    faq.def.container.addClass('active-content');

    if (categoryElement.hasClass('fixed')) {
        faq.def.container.addClass('fixed');
    }

    faq.getContentFromFolder(categoryElement.attr('data-href'), activeQuestionId);

    window.scrollTo(0, 0);
}

function setUrl(url){
    //Clean the URL in case the ? was left over
    if (url[url.length - 1] == '?') {
        url = url.slice(0, -1);
    }

    window.history.replaceState([], null, url);
}

function replaceParameterInUrl(url, name, value){
    const clean = removeParamFromURL(url, name);
    return appendParamToURL(clean, name, value);
}

module.exports = faq;
